(() => {
  const root = document.querySelector('.vinyl-club-page');
  if (!root) return;

  let audioPlaying = false;


  function spotifyCanonicalUrl(embedUrl) {
    if (!embedUrl) return '';
    try {
      const url = new URL(embedUrl, window.location.origin);
      if (!/open\.spotify\.com$/i.test(url.hostname)) return '';
      return 'https://open.spotify.com' + url.pathname.replace(/^\/embed\//, '/');
    } catch (_) {
      return '';
    }
  }

  function loadMonthlyPlaylistArtwork() {
    const art = document.querySelector('[data-vc-playlist-art]');
    if (!art) return;
    if (art.getAttribute('data-manual-artwork') === 'true') return;
    const canonical = spotifyCanonicalUrl(art.getAttribute('data-spotify-url'));
    if (!canonical) return;
    const initialImg = art.querySelector('[data-vc-playlist-image]');
    const initialFallback = art.querySelector('[data-vc-playlist-fallback]');
    if (initialImg && !initialImg.dataset.errorBound) {
      initialImg.dataset.errorBound = 'true';
      initialImg.addEventListener('error', () => { if (initialFallback) initialFallback.hidden = false; });
      initialImg.addEventListener('load', () => { if (initialFallback) initialFallback.hidden = true; });
    }
    fetch('https://open.spotify.com/oembed?url=' + encodeURIComponent(canonical) + '&_=' + Date.now(), {
      method: 'GET', mode: 'cors', credentials: 'omit'
    })
      .then((response) => {
        if (!response.ok) throw new Error('Artwork request failed');
        return response.json();
      })
      .then((data) => {
        if (!data || !data.thumbnail_url) return;
        const img = art.querySelector('[data-vc-playlist-image]');
        const fallback = art.querySelector('[data-vc-playlist-fallback]');
        if (!img) return;
        img.src = data.thumbnail_url;
        img.alt = (data.title || 'Let Us Put You On') + ' playlist artwork';
        img.hidden = false;
        art.classList.remove('monthly-playlist-art--placeholder');
        if (fallback) fallback.hidden = true;
      })
      .catch(() => {});
  }

  window.toggleAudio = function toggleAudio() {
    const dot = document.getElementById('audio-dot');
    const label = document.getElementById('audio-label');
    const btn = document.getElementById('audio-toggle');
    const vinyl = document.querySelector('.vinyl');
    const audio = document.getElementById('audio-player');
    if (!audio || !audio.getAttribute('src')) return;

    audioPlaying = !audioPlaying;
    if (audioPlaying) {
      if (audio.readyState < 2) audio.load();
      audio.play().then(() => {
        if (dot) dot.style.animation = 'pulse 1s ease-in-out infinite';
        if (label) label.textContent = 'Now playing';
        if (btn) {
          btn.style.borderColor = '#750f7e';
          btn.style.color = '#750f7e';
        }
        if (vinyl) vinyl.style.animationPlayState = 'running';
      }).catch(() => {
        audioPlaying = false;
        if (dot) dot.style.animation = '';
        if (label) label.textContent = 'Play music';
        if (btn) {
          btn.style.borderColor = '#242424';
          btn.style.color = '#888580';
        }
      });
    } else {
      audio.pause();
      if (dot) dot.style.animation = '';
      if (label) label.textContent = 'Play music';
      if (btn) {
        btn.style.borderColor = '#242424';
        btn.style.color = '#888580';
      }
      if (vinyl) vinyl.style.animationPlayState = 'paused';
    }
  };


  function initSubscriptionTierForms(scope = document) {
    const forms = Array.from(scope.querySelectorAll('[data-vc-subscription-form]'));

    forms.forEach((form) => {
      if (form.dataset.vcBound === 'true') return;
      form.dataset.vcBound = 'true';

      const sellingPlanInput = form.querySelector('[data-vc-selling-plan-input]');
      const sellingPlanSelect = form.querySelector('[data-vc-selling-plan-select]');
      const submit = form.querySelector('[data-vc-subscription-submit]');
      const error = form.querySelector('[data-vc-purchase-error]');
      const card = form.closest('.tier-card');
      const price = card ? card.querySelector('[data-vc-tier-price]') : null;

      if (sellingPlanSelect && sellingPlanInput) {
        sellingPlanSelect.addEventListener('change', () => {
          const option = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
          sellingPlanInput.value = sellingPlanSelect.value;
          if (price && option && option.dataset.displayPrice) price.textContent = option.dataset.displayPrice;
        });
      }

      form.addEventListener('submit', async (event) => {
        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const sellingPlan = sellingPlanInput ? sellingPlanInput.value : '';
        const variantId = variantInput ? Number.parseInt(variantInput.value, 10) : 0;
        const quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) || 1 : 1;

        if (!variantId || !sellingPlan) return;

        event.preventDefault();
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
        }

        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        try {
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity,
                selling_plan: Number.parseInt(sellingPlan, 10) || sellingPlan
              }]
            })
          });

          let payload = null;
          try { payload = await response.json(); } catch (_) {}

          if (!response.ok) {
            const message = payload && (payload.description || payload.message || payload.status);
            throw new Error(message || 'Unable to add this subscription to the cart.');
          }

          if (form.dataset.purchaseDestination === 'cart') {
            window.location.assign(`${rootUrl}cart`);
          } else {
            window.location.assign(`${rootUrl}checkout`);
          }
        } catch (purchaseError) {
          if (error) {
            error.textContent = purchaseError && purchaseError.message
              ? purchaseError.message
              : 'We could not start this subscription. Please try again.';
            error.hidden = false;
          }
          if (submit) {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
          }
        }
      });
    });
  }


  function initGiftMembershipForms(scope = document) {
    const forms = Array.from(scope.querySelectorAll('[data-vc-gift-form]'));

    forms.forEach((form) => {
      if (form.dataset.vcGiftBound === 'true') return;
      form.dataset.vcGiftBound = 'true';

      const dataNode = form.querySelector('[data-vc-gift-data]');
      const variantSelect = form.querySelector('[data-vc-gift-variant-select]');
      const planSelect = form.querySelector('[data-vc-gift-plan-select]');
      const variantInput = form.querySelector('[data-vc-gift-variant-input]');
      const planInput = form.querySelector('[data-vc-gift-plan-input]');
      const due = form.querySelector('[data-vc-gift-due]');
      const delivery = form.querySelector('[data-vc-gift-delivery]');
      const summary = form.querySelector('[data-vc-gift-summary]');
      const submit = form.querySelector('[data-vc-gift-submit]');
      const error = form.querySelector('[data-vc-gift-error]');
      if (!dataNode || !variantSelect || !planSelect || !variantInput || !planInput) return;

      let data;
      try { data = JSON.parse(dataNode.textContent); } catch (parseError) {
        console.error('[Who\'s AUX] Unable to parse gift membership data.', parseError);
        return;
      }

      const getVariant = () => data.variants && data.variants[String(variantSelect.value)];

      const updatePlanDetails = () => {
        const variant = getVariant();
        const plans = variant && Array.isArray(variant.plans) ? variant.plans : [];
        const plan = plans.find((entry) => String(entry.id) === String(planSelect.value)) || plans[0];
        if (!plan) {
          planInput.value = '';
          if (summary) summary.hidden = true;
          if (submit) submit.disabled = true;
          return;
        }
        planSelect.value = String(plan.id);
        planInput.value = String(plan.id);
        if (due) due.textContent = plan.due || '';
        if (delivery) delivery.textContent = plan.perDelivery || '';
        if (summary) summary.hidden = false;
        if (submit) submit.disabled = !variant.available;
      };

      const renderPlans = () => {
        const variant = getVariant();
        variantInput.value = variant ? String(variant.id) : '';
        planSelect.innerHTML = '';
        const plans = variant && Array.isArray(variant.plans) ? variant.plans : [];
        plans.forEach((plan) => {
          const option = document.createElement('option');
          option.value = String(plan.id);
          option.textContent = plan.name;
          planSelect.appendChild(option);
        });
        planSelect.disabled = !variant || !variant.available || !plans.length;
        updatePlanDetails();
      };

      variantSelect.addEventListener('change', renderPlans);
      planSelect.addEventListener('change', updatePlanDetails);

      form.addEventListener('submit', async (event) => {
        const variantId = Number.parseInt(variantInput.value, 10) || variantInput.value;
        const sellingPlan = Number.parseInt(planInput.value, 10) || planInput.value;
        if (!variantId || !sellingPlan) {
          event.preventDefault();
          if (error) {
            error.textContent = 'Choose an available tier and gift length before continuing.';
            error.hidden = false;
          }
          return;
        }

        event.preventDefault();
        if (error) { error.hidden = true; error.textContent = ''; }
        if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        try {
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: sellingPlan }] })
          });
          let payload = null;
          try { payload = await response.json(); } catch (_) {}
          if (!response.ok) {
            const message = payload && (payload.description || payload.message || payload.status);
            throw new Error(message || 'Unable to add this gift membership to the cart.');
          }
          window.location.assign(form.dataset.purchaseDestination === 'cart' ? `${rootUrl}cart` : `${rootUrl}checkout`);
        } catch (purchaseError) {
          if (error) {
            error.textContent = purchaseError && purchaseError.message ? purchaseError.message : 'We could not add this gift membership. Please try again.';
            error.hidden = false;
          }
          if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
        }
      });

      renderPlans();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const vinyl = document.querySelector('.vinyl');
    const audio = document.getElementById('audio-player');
    const slides = Array.from(document.querySelectorAll('.why-hero-slide'));
    const dotsContainer = document.querySelector('.why-hero-dots');
    const prevBtn = document.querySelector('.why-hero-arrow:first-of-type');
    const nextBtn = document.querySelector('.why-hero-arrow:last-of-type');
    const navToggle = document.querySelector('.nav-toggle');
    const nav = document.querySelector('nav');
    const mobileLinks = Array.from(document.querySelectorAll('.nav-mobile a'));
    const navMobile = document.querySelector('.nav-mobile');
    if (navToggle && nav && navMobile) {
      navToggle.setAttribute('aria-expanded', 'false');
      navMobile.setAttribute('aria-hidden', 'true');
      navToggle.addEventListener('click', () => {
        const isOpen = !nav.classList.contains('open');
        nav.classList.toggle('open', isOpen);
        navToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        navToggle.setAttribute('aria-expanded', isOpen.toString());
        navToggle.textContent = isOpen ? '✕' : '☰';
        navMobile.setAttribute('aria-hidden', (!isOpen).toString());
      });
    }

    if (nav && navToggle && mobileLinks.length && navMobile) {
      mobileLinks.forEach((link) => {
        link.addEventListener('click', () => {
          nav.classList.remove('open');
          navToggle.setAttribute('aria-label', 'Open menu');
          navToggle.setAttribute('aria-expanded', 'false');
          navToggle.textContent = '☰';
          navMobile.setAttribute('aria-hidden', 'true');
        });
      });
    }

    if (slides.length && dotsContainer) {
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'why-hero-dot' + (index === 0 ? ' active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dotsContainer.appendChild(dot);
      });

      const dots = Array.from(document.querySelectorAll('.why-hero-dot'));
      let currentSlide = 0;
      let slideTimer;

      const showSlide = (index) => {
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('active', isActive);
          slide.style.display = isActive ? 'flex' : 'none';
          slide.style.opacity = isActive ? '1' : '0';
        });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === index));
        currentSlide = index;
      };

      const nextSlide = () => showSlide((currentSlide + 1) % slides.length);
      const startSlider = () => {
        clearInterval(slideTimer);
        slideTimer = setInterval(nextSlide, 6000);
      };

      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        showSlide(index);
        startSlider();
      }));
      if (prevBtn) prevBtn.addEventListener('click', () => {
        showSlide((currentSlide - 1 + slides.length) % slides.length);
        startSlider();
      });
      if (nextBtn) nextBtn.addEventListener('click', () => {
        nextSlide();
        startSlider();
      });

      showSlide(0);
      startSlider();
    }

    if (vinyl) {
      vinyl.style.animationPlayState = 'paused';
      vinyl.addEventListener('click', window.toggleAudio);
      vinyl.title = 'Click to play music';
      vinyl.style.cursor = 'pointer';
      vinyl.addEventListener('mouseenter', () => { if (!audioPlaying) vinyl.style.animationPlayState = 'paused'; });
      vinyl.addEventListener('mouseleave', () => { if (!audioPlaying) vinyl.style.animationPlayState = 'paused'; });
    }

    if (audio) {
      audio.addEventListener('ended', () => {
        audioPlaying = false;
        const dot = document.getElementById('audio-dot');
        const label = document.getElementById('audio-label');
        const btn = document.getElementById('audio-toggle');
        if (dot) dot.style.animation = '';
        if (label) label.textContent = 'Play music';
        if (btn) {
          btn.style.borderColor = '#242424';
          btn.style.color = '#888580';
        }
        if (vinyl) vinyl.style.animationPlayState = 'paused';
      });
    }

    loadMonthlyPlaylistArtwork();
    initSubscriptionTierForms(root);
    initGiftMembershipForms(root);
  });

  document.addEventListener('shopify:section:load', () => {
    loadMonthlyPlaylistArtwork();
    initSubscriptionTierForms(document);
    initGiftMembershipForms(document);
  });
})();
